import {ApplicationConfig} from '@angular/core';
import {appRoutes, PATH_FOR} from './app.routes';
import {RouteName} from '@app/app.route-names.generated';
import {provideStore} from '@ngrx/store';
import {Environment} from '@environment/environment.type';
import {environment} from '@environment/environment';
import {API_URL, ROUTER_PATH_FOR} from '@aviary/injection-tokens/app-provided.tokens';
import {JwtTokenInterceptor} from '@aviary/interceptors/jwt-token.interceptor';
import {OrganizationSelectors} from '@store/organization/organization.selectors';
import {provideAviaryDateDefaults} from '@aviary/providers/date-defaults.provider';
import {provideAviaryStore} from '@aviary/store/store.providers';
import {provideAngularPipes} from '@aviary/providers/angular-pipes.provider';
import {providePhoenixStore} from '@store/store.providers';
import {provideAviaryCoverImages} from '@aviary/providers/cover-image.provider';
import {provideAviaryHttp} from '@aviary/providers/http.provider';
import {provideAviaryTableExpansionSettings} from '@aviary/providers/table-expansion-settings.provider';
import {provideAviaryRouterStore} from '@aviary/providers/router-store.provider';
import {provideAviaryAnimations} from '@aviary/providers/animations.provider';
import {provideAviaryStoreDevtools} from '@aviary/providers/store-devtools.provider';
import {provideAviaryRouter} from '@aviary/providers/router.provider';
import {provideAviaryTooltipDefaults} from '@aviary/providers/tooltip-defaults.provider';
import {provideFirebase} from '@aviary/providers/firebase.provider';
import {provideAviaryTableColumnSettings} from '@aviary/providers/table-column-settings.provider';
import {provideAviaryPaginatorSettings} from '@aviary/providers/paginator.provider';
import {provideAviaryButtonAppConfig} from '@aviary/providers/button-app-config.provider';
import {provideAviaryDialogAppConfig} from '@aviary/providers/dialog-app-config.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    // App-specific values
    {provide: Environment, useValue: environment},
    {provide: API_URL, useValue: environment.apiUrl},
    {provide: ROUTER_PATH_FOR, useValue: PATH_FOR},

    // Firebase
    provideFirebase(environment),

    // HTTP
    provideAviaryHttp<RouteName>(JwtTokenInterceptor),

    // NgRx
    provideStore(),
    provideAviaryStoreDevtools(environment),
    provideAviaryStore(),
    providePhoenixStore(),

    // Routing
    provideAviaryRouter(appRoutes),
    provideAviaryRouterStore(),

    // UI
    provideAngularPipes(),
    provideAviaryAnimations(),
    provideAviaryButtonAppConfig({
      focusRingPosition: 'inside',
      splitButtonToggleIcon: 'expand_more',
      defaultColors: {
        filled: 'primary',
        outlined: 'primary',
        text: 'secondary',
        elevated: 'primary',
        split: 'primary',
        icon: 'primary',
        fab: 'primary'
      }
    }),
    provideAviaryCoverImages({
      coverImageSourceSelector: OrganizationSelectors.Auth.coverImageSource,
      fallbackCoverImageUrl: '/assets/fallback_cover_image.png',
    }),
    provideAviaryDateDefaults(),
    provideAviaryDialogAppConfig({
      cancelButtonType: 'outlined',
      showActionsDivider: true
    }),
    provideAviaryPaginatorSettings('PAGE_NUMBERS'),
    provideAviaryTableExpansionSettings('PLUS_MINUS', 'END'),
    provideAviaryTableColumnSettings(true),
    provideAviaryTooltipDefaults()
  ]
};
